import { Component, Prop, Vue } from 'vue-property-decorator';

import { ISwappableListItem } from '@andromeda/calvera-prototype-multi-retailer-cart-data-access-store';

import Checkbox from '../checkbox';

@Component({
    components: {
        Checkbox,
    },
})

export default class SwappableListItem<T> extends Vue {
    @Prop({ required: true }) listItem!: ISwappableListItem<T>;
}
